import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 8px;
  margin-bottom: 16px;
`

export const RequirementsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const Requirement = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  color: ${({ $met, theme }) => ($met ? theme.success : theme.danger)};
  transition: color 0.2s ease;
`

export const Icon = styled.span`
  font-weight: bold;
  font-size: 1rem;
`
